import {ReactElement} from 'react';
import {ProgressChartDataSetType} from './AurProgressChart';

interface ProgressBarStripeDataType {
  filled: boolean;
  width: number;
  height: number;
  spaceBetween: number;
  color: string;
  unfilledColor?: string;
  toolTip?: string | ReactElement | null;
}

export const convertStringToNumber = (input: string) => {
  // Parse as a number
  const num = Number(input);

  if (isNaN(num)) {
    // might receive input = "" or invalid string value so return 0 if it's not valid
    return 0;
  }
  return Number.isInteger(num) ? parseInt(input, 10) : num;
};

export const generateProgressBarStripes = (
  dataSet: ProgressChartDataSetType[],
  containerWidth: number,
  layout: {
    barWidth: number;
    spaceBetweenBar: number;
    barHeight: number;
  } = {barWidth: 5.2, spaceBetweenBar: 1, barHeight: 48}
): ProgressBarStripeDataType[] => {
  const stripeWidth = layout.barWidth;
  const spaceBetweenStripes = layout.spaceBetweenBar;
  const totalStripeWidth = stripeWidth + spaceBetweenStripes;

  // Calculate how many stripes bar fit in the container as per available space
  const totalStripes = Math.floor(containerWidth / totalStripeWidth);

  // Calculate total value of all dataSet's
  const totalSectionSum = dataSet.reduce(
    (sum, section) => sum + section.total,
    0
  );

  // Create an array to hold the stripes data
  const stripeData: ProgressBarStripeDataType[] = [];

  // Generate and distribute number of strips based on single data set's total value and it's progress under container
  dataSet.forEach((section, sectionIndex) => {
    const {total, progress, filledColor, unfilledColor} = section;

    // Calculate the ratio of this section to the total
    const sectionRatio = section.total / totalSectionSum;
    let stripesForSection = Math.floor(sectionRatio * totalStripes);

    // Ensure at least two stripes are assigned to every section
    stripesForSection = Math.max(stripesForSection, 2);

    // Calculate how many of these stripes should be filled based on progress
    let filledStripes = Math.floor((progress / total) * stripesForSection);

    // Ensure at least one strip show filled if have any progress
    if (progress > 0 && filledStripes === 0) {
      filledStripes = 1;
    }
    // Generate the stripes for this section
    for (let i = 0; i < stripesForSection; i++) {
      stripeData.push({
        color: filledColor,
        filled: i < filledStripes,
        unfilledColor,
        width: stripeWidth,
        spaceBetween: spaceBetweenStripes,
        height: layout.barHeight,
        toolTip:
          i < filledStripes
            ? section.tooltip?.filled
            : section.tooltip?.unFilled,
      });
    }

    // Add a blank stripe between sections, except after the last section
    if (sectionIndex < dataSet.length - 1) {
      stripeData.push({
        color: 'transparent',
        filled: false,
        width: stripeWidth,
        spaceBetween: spaceBetweenStripes,
        height: layout.barHeight,
      });
    }
  });

  return stripeData;
};
